import { createFileRoute } from '@tanstack/react-router'
import { PatientRecordViewer } from '@/features/patient-record'

export const Route = createFileRoute('/medical/$token')({
  component: function PatientRecordPage() {
    const { token } = Route.useParams()
    return (
      <div className="min-h-screen bg-background">
        <PatientRecordViewer token={token} />
      </div>
    )
  },
})
